module.exports = __webpack_public_path__ + "img/toolbox.327b633b.png";